
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsac3442d77ad731f0cba004d16a7aa2bben from './en.yaml'
            i18n.addResourceBundle('en', 'ac3442d77ad731f0cba004d16a7aa2bb', flattenObject(nsac3442d77ad731f0cba004d16a7aa2bben), true, true);
        
        export default 'ac3442d77ad731f0cba004d16a7aa2bb';
    